module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-segment-js/gatsby-browser.js'),
      options: {"plugins":[],"prodKey":"5xxRf16nuU6L4YxnH36hPmTaI2PBuxS3","devKey":"JPpe1pIe8mx3aDdXc6vD18QmVxQ55OyI","trackPage":false,"delayLoad":true,"delayLoadTime":1000},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
